// extracted by mini-css-extract-plugin
module.exports = {"filesList":"filesList_3oBaL","fileInfo":"fileInfo_1ZDNc","download":"download_2Dj8p","deleteIcon":"deleteIcon_2jJ29"};